import { webConstants } from "@payping/utils/platformConstants";

const {
  home: homeRoutes,
  report: reportRoutes,
  ipg: ipgRoutes,
  invoice: invoiceRoutes,
  customer: customerRoutes,
  // platform: platformRoutes,
  product: productRoutes,
  requestMoney: requestMoneyRoutes,
  user: userRoutes,
} = webConstants.DashboardRoutes;

const create = ["ساخت", "ایجاد", "جدید", "create", "add"];
const bulk = ["دسته", "bulk"];
const list = ["لیست", "list"];
const item = ["ایتم", "item"];
const customer = ["مشتریان", "customers"];
const coupon = ["کدتخفیف", "کوپن", "coupon", "discount"];
const invoice = ["فاکتور", "invoice"];
const report = ["گزارش", "report"];
const requestMoney = ["درخواست پول", "request money"];
const wordpress = ["وردپرس", "wordpress"];

/**
 * NOTE: Do not use upperCase value in searchData, because before search all values are converted to lowerCase
 * Other not allowed characters:
 * ي
 * ك
 * آ
 */
export const searchData: Record<string, string[]> = {
  [homeRoutes.messages]: [...report, "اعلانات", "پیام", "messages", "notifications"],
  [reportRoutes.itemSale]: [...report, "فروش", "ایتم", "محصول", "item sale", "product sale"],
  [homeRoutes.overview]: [...report, "در یک نگاه", "کلی", "خانه", "home", "main"],
  [reportRoutes.summation]: [
    ...report,
    "تجمیعی",
    "پیشرفته",
    "پرداخت",
    "تراکنش",
    "summation",
    "advanced",
    "transaction",
    "payment",
    "accumulative",
  ],
  [reportRoutes.transactions.root]: [...report, "تراکنش", "خرید", "transaction", ...list],
  [reportRoutes.withdraws.root]: [...report, "تسویه", "تسفیه", "برداشت", "withdraw", "settlement", ...list],
  [ipgRoutes.oauth.root]: [
    "پلفترم",
    "توکن",
    "کلاینت",
    "برنامه",
    "oauth",
    "oauth2",
    "identity",
    "openid",
    "open authentication",
    "token",
    "client",
    "application",
  ],
  [ipgRoutes.oauth.create]: [
    "پلفترم",
    "توکن",
    "کلاینت",
    "برنامه",
    "oauth",
    "oauth2",
    "identity",
    "openid",
    "open authentication",
    "token",
    "client",
    "application",
    ...create,
  ],
  [ipgRoutes.token.root]: [
    "توکن",
    "درگاه",
    "درگاه پرداخت",
    "درگاه ساده",
    "token",
    "client",
    "plugin",
    "webservice",
    "api",
  ],
  [ipgRoutes.token.create]: [
    "توکن",
    "درگاه",
    "درگاه پرداخت",
    "درگاه ساده",
    "token",
    "client",
    "plugin",
    "webservice",
    "api",
    ...create,
  ],
  [ipgRoutes.service.root]: ["سرویس", "service"],
  [ipgRoutes.service.detail.replace(":name", "trust")]: ["نماد", "اعتماد", "پی‌پینگ", "payping", "donate"],
  [ipgRoutes.service.detail.replace(":name", "githubDonate")]: ["حمایت‌مالی", "گیتهاب", "گیت هاب", "github"],
  [ipgRoutes.service.detail.replace(":name", "donateScript")]: ["حمایت‌مالی", "donate script"],
  [ipgRoutes.service.detail.replace(":name", "slack")]: ["اسلک", "slack", "پیام‌رسانی", "messaging"],
  [ipgRoutes.service.detail.replace(":name", "telegram")]: [
    "تلگرام",
    "telegram",
    "پیام‌رسانی",
    "messaging",
    "ربات",
    "bot",
  ],
  [ipgRoutes.service.detail.replace(":name", "kavehNegar")]: [
    "کاوه نگار",
    "kaveh negar",
    "kavenegar",
    "پیام‌رسانی",
    "messaging",
  ],
  [ipgRoutes.service.detail.replace(":name", "mailerLite")]: [
    "میلرلایت",
    "mailer lite",
    "mailerlite",
    "پیام‌رسانی",
    "messaging",
  ],
  [ipgRoutes.service.detail.replace(":name", "J2Store")]: ["j2store"],
  [ipgRoutes.service.detail.replace(":name", "prestaShop")]: ["پرستاشاپ", "prestashop"],
  [ipgRoutes.service.detail.replace(":name", "whmcs")]: ["whmcs"],
  [ipgRoutes.service.detail.replace(":name", "opencart")]: ["opencart"],
  [ipgRoutes.service.detail.replace(":name", "virtualFreer")]: ["virtual freer"],
  [ipgRoutes.service.detail.replace(":name", "nopCommerce")]: ["nopcommerce"],
  [ipgRoutes.service.detail.replace(":name", "wooCommerce")]: ["ووکامرس", "woocommerce", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "wooCommerceVIP")]: ["ووکامرس vip", "woocommerce vip", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "gravityForms")]: ["gravityForms", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "easyDigital")]: ["easydigital", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "donatePlugin")]: ["حمایت‌مالی", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "paidPro")]: ["paidpro", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "proVIP")]: ["pro-vip", "provip", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "give")]: ["give", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "classiPress")]: ["classipress", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "myCred")]: ["mycred", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "restrictContentPro")]: ["restrictcontentpro", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "learnPress")]: ["learnpress", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "contactForm7")]: ["contactform7", ...wordpress],
  [ipgRoutes.service.detail.replace(":name", "WPUserFrontend")]: ["wpuserfrontend", ...wordpress],
  [ipgRoutes.document]: ["مستندات", "نمونه کد", "document", "code", "example"],
  [requestMoneyRoutes.list]: [...requestMoney],
  [requestMoneyRoutes.request]: [...requestMoney, ...create],
  [requestMoneyRoutes.bulkRequest]: [...requestMoney, ...bulk, ...create],
  [customerRoutes.list]: [...customer, ...list],
  [customerRoutes.create]: [...customer, ...create],
  [customerRoutes.createBulk]: [...customer, ...bulk, ...create],
  [productRoutes.list]: [...item, ...list],
  [`${productRoutes.list}?isArchived=true`]: ["ارشیو", "archived", ...item, ...list],
  [productRoutes.create]: [...item, ...create],
  [productRoutes.createBulk]: [...item, ...bulk, ...create],
  [productRoutes.coupon.list]: [...item, ...coupon, ...list],
  [`${productRoutes.coupon.list}?isArchived=true`]: ["ارشیو", "archived", ...item, ...coupon, ...list],
  [productRoutes.coupon.create]: [...item, ...coupon, ...create],
  [invoiceRoutes.list]: [...invoice, ...list],
  [`${invoiceRoutes.list}?isArchived=true`]: ["ارشیو", "archived", ...invoice, ...list],
  [invoiceRoutes.create]: [...invoice, ...create],
  [invoiceRoutes.coupon.list]: [...invoice, ...coupon, ...list],
  [`${invoiceRoutes.coupon.list}?isArchived=true`]: ["ارشیو", "archived", ...invoice, ...coupon, ...list],
  [invoiceRoutes.coupon.create]: [...invoice, ...coupon, ...create],
  // TODO: add platform project routes
  // [platformRoutes.list]: ["", ...list],
  [userRoutes.settings.root]: ["تنظیمات", "settings", "حساب کاربری", "account"],
  [userRoutes.settings.display]: ["تنظیمات نمایش", "display settings"],
  [userRoutes.settings.messaging]: ["اطلاع رسانی", "notification"],
  [userRoutes.settings.password]: ["تغییر رمز عبور", "change", "password"],
  [userRoutes.settings.terminal]: ["شخصی سازی درگاه", "terminal customization"],
  [userRoutes.settings["2fa"]]: ["رمز دو مرحله ای", "otp", "2factor"],
  [userRoutes.requestWithdraw]: ["درخواست تسویه", "withdraw", "settlement", "request"],
  [userRoutes.upgrade]: ["تعرفه‌ها", "پلن‌ها", "ارتقاء", "tariffs", "plans", "upgrade"],
  [userRoutes.profile.root]: ["پروفایل", "profile", "حساب کاربری", "account"],
  [userRoutes.profile.personal]: ["اطلاعات", "فردی", "information", "personal"],
  [userRoutes.profile.business]: ["اطلاعات", "کسب و کار", "کسب‌و‌کار", "information", "business"],
  [userRoutes.profile.bank]: ["اطلاعات", "بانکی", "شبا", "information", "bank", "sheba", "iban"],
  [userRoutes.profile.local]: ["اطلاعات", "محلی", "information", "local"],
  [userRoutes.profile.social]: [
    "شبکه‌های اجتماعی",
    "تلگرام",
    "اینستاگرام",
    "توییتر",
    "توئیتر",
    "وبسایت",
    "وب سایت",
    "social",
    "telegram",
    "instagram",
    "twitter",
    "website",
  ],
  [userRoutes.referral]: [...report, "ریفرال", "درآمد", "کسب درآمد", "معرفی", "referral", "affiliate"],
};
